<template>
  <div class="check-list-action auto-list_col_centered">
    <div class="admin__actions">
      <div>
        <img
          src="@/assets/img/move_reposnse.png"
          width="40"
          class="admin__move"
          @click="$emit('open')"
        />
      </div>
      <div>
        <el-button
          type="danger"
          icon="el-icon-delete"
          circle
          @click="deleteResponse(response.bid_id, response.id)"
        />
      </div>
    </div>

    <div
      :class="['admin__comment', { filled: Boolean(response.admin_comment) }]"
      @click="isCommentOpen = true"
    >
      Коммент
    </div>

    <ResponseCommentModal
      v-if="isCommentOpen"
      :response="response"
      :is-visible="isCommentOpen"
      @comment="setComment"
      @close="isCommentOpen = false"
    />
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import ResponseCommentModal from '@/components/Modals/ResponseCommentModal.vue'

const Bids = RepositoryFactory.get('bids')

export default {
  name: 'Action',
  components: { ResponseCommentModal },
  props: {
    response: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isCommentOpen: false,
    }
  },
  methods: {
    deleteResponse(bid_id, id) {
      this.$confirm('Вы уверены что хотите удалить?', '', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Отмена',
        type: 'warning',
        customClass: this.isMobile ? 'before-del' : '',
      }).then(() => {
        Bids.deleteBidRequest(bid_id, id).then(() => {
          this.$emit('delete')
        })
      })
    },
    setComment() {
      this.isCommentOpen = false
      this.$emit('comment')
    },
  },
}
</script>

<style lang="sass" scoped>
.bids-list .middle-section .check-list .auto-list_col .check-list-action
  display: flex
  flex-direction: column
  justify-content: center

  .admin__move
    margin: 0 10px
  .admin__actions
    display: flex
    justify-content: center
    align-items: flex-start
  .admin__comment
    margin-top: 6px
    text-align: center
    font-size: 14px
    font-weight: 700
    color: #98A9BC
    cursor: pointer
    &.filled
      color: #67C23A
      &:hover
        color: #85ce61
</style>
